import FAEventCardMeta from './FAEventCardMeta'
export default FAEventCardMeta
